export const CARDS_TO_DISPLAY = 4;
export const CARDS_TO_FETCH = 12;
export const YEARS_TO_SHOW = 3;
export const MAX_YEARS_TO_SHOW = 15;
